import styled from 'styled-components';
import { transparentize } from 'polished';
import { colors } from '@keen.io/colors';
import { StepContainer } from '../FunnelStep/FunnelStep.styles';
export var AddStep = styled.div.withConfig({
  displayName: "FunnelStepsstyles__AddStep",
  componentId: "keen-query-creator__sc-10m82o8-0"
})(["&&&{display:flex;align-items:center;padding:20px;background:", ";border:1px dashed ", ";font-family:Lato Bold,sans-serif;font-size:16px;color:", ";text-align:left;cursor:pointer;transition:background 0.2s linear;}&&&:hover{background:", ";}"], transparentize(0.9, colors.green[300]), colors.green[300], colors.green[500], transparentize(0.6, colors.green[300]));
export var IconWrapper = styled.div.withConfig({
  displayName: "FunnelStepsstyles__IconWrapper",
  componentId: "keen-query-creator__sc-10m82o8-1"
})(["&&&{margin-right:6px;}"]);
export var Container = styled.div.withConfig({
  displayName: "FunnelStepsstyles__Container",
  componentId: "keen-query-creator__sc-10m82o8-2"
})(["&&& ", " + ", "{margin-top:10px;}&&& ", " + ", "{margin-top:10px;}"], StepContainer, StepContainer, StepContainer, AddStep);